import '../modules/recipient-form'

document.addEventListener('DOMContentLoaded', () => {
  const ThumbnailButtons = document.querySelectorAll('.Product__SlideshowNavScrollButton')
  const ThumbnailScroller = document.querySelector('.Product__SlideshowNavScroller')
  const Thumbnails = document.querySelectorAll('.Product__SlideshowNavImage')
  const scrollThumbnail = (dir = 'next') => {
    if (!ThumbnailScroller) return
    const targetScroll = dir === 'next'
      ? ThumbnailScroller.scrollTop + ThumbnailScroller.clientHeight
      : Math.max(0, ThumbnailScroller.scrollTop - ThumbnailScroller.clientHeight)
    ThumbnailScroller.scrollTo({ top: targetScroll, behavior: 'smooth' })
  }
  const scrollToTarget = target => {
    if (!ThumbnailScroller) return
    if (ThumbnailScroller.scrollTop >= target.offsetTop || ThumbnailScroller.scrollTop + 400 <= target.offsetTop) {
      ThumbnailScroller.scrollTo({ top: target.offsetTop - 27, behavior: 'smooth' })
    }
  }
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      const target = mutation.target
      if (target.classList.contains('is-selected')) {
        scrollToTarget(target)
      }
    })
  })
  ThumbnailButtons.length && ThumbnailButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (button.hasAttribute('data-prev')) {
        scrollThumbnail('prev')
      }
      else if (button.hasAttribute('data-next')) {
        scrollThumbnail()
      }
    })
  })
  Thumbnails.length && Thumbnails.forEach(thumbnail => {
    const config = {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class']
    }
    observer.observe(thumbnail, config)
  })
})
